import { useEffect, useState } from "react";
import { useTelegram } from "../../context/TelegramContext";
import AddToHomeScreen from "./AddToHomeScreen";

// Показуємо попап не частіше ніж раз на 7 днів (якщо юзер закрив "Майбутнє").
const DISMISS_COOLDOWN_MS = 7 * 24 * 60 * 60 * 1000;
// Чекаємо перед показом, щоб не вилізти поверх premium-попапу або першого рендеру.
const SHOW_DELAY_MS = 3500;

export default function AddToHomeScreenManager() {
  const tg = useTelegram();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!tg?.initData) return;

    // addToHomeScreen() API доступне лише на iOS та Android.
    const platform = tg?.platform;
    if (platform !== "ios" && platform !== "android") return;

    // Якщо premium popup вже виліз у цій сесії — не навантажуємо юзера другим.
    if (sessionStorage.getItem("premiumPopupShown") === "true") return;

    // Вже показувався цієї сесії — не дублюємо.
    if (sessionStorage.getItem("addToHomeScreenShown") === "true") return;

    // Якщо нещодавно закрив попап (cooldown 7 днів) — чекаємо.
    const lastDismissedAt = parseInt(
      localStorage.getItem("addToHomeScreenDismissedAt"),
      10
    );
    if (
      !isNaN(lastDismissedAt) &&
      Date.now() - lastDismissedAt < DISMISS_COOLDOWN_MS
    ) {
      return;
    }

    let cancelled = false;
    let timer = null;

    const scheduleShow = () => {
      timer = setTimeout(() => {
        if (cancelled) return;
        if (sessionStorage.getItem("premiumPopupShown") === "true") return;

        sessionStorage.setItem("addToHomeScreenShown", "true");
        setShow(true);
      }, SHOW_DELAY_MS);
    };

    // Якщо API нема на цьому клієнті — вважаємо "missed" (покажемо попап).
    if (typeof tg.checkHomeScreenStatus !== "function") {
      if (localStorage.getItem("addToHomeScreenAdded") === "true") return;
      scheduleShow();
    } else {
      try {
        // checkHomeScreenStatus викликає callback异步 із статусом:
        //   "unsupported" — платформа не підтримує додавання
        //   "added"       — вже додано
        //   "missed"      — не додано
        //   "unknown"     — платформа підтримує, статус невідомий
        tg.checkHomeScreenStatus((status) => {
          if (cancelled) return;
          if (status === "unsupported") return;
          if (status === "added") {
            localStorage.setItem("addToHomeScreenAdded", "true");
            return;
          }
          // "missed" або "unknown" — показуємо.
          scheduleShow();
        });
      } catch (e) {
        console.warn("checkHomeScreenStatus failed:", e);
        scheduleShow();
      }
    }

    // Підписка на homeScreenAdded: якщо юзер додав іконку будь-яким шляхом
    // (через наш попап, через інший шлях у Telegram) — запам'ятовуємо це,
    // щоб більше не пропонувати.
    const onHomeScreenAdded = () => {
      localStorage.setItem("addToHomeScreenAdded", "true");
      sessionStorage.setItem("addToHomeScreenShown", "true");
      setShow(false);
    };

    if (typeof tg.onEvent === "function") {
      try {
        tg.onEvent("homeScreenAdded", onHomeScreenAdded);
      } catch (e) {
        console.warn("onEvent homeScreenAdded failed:", e);
      }
    }

    return () => {
      cancelled = true;
      if (timer) clearTimeout(timer);
      if (typeof tg.offEvent === "function") {
        try {
          tg.offEvent("homeScreenAdded", onHomeScreenAdded);
        } catch (e) {}
      }
    };
  }, [tg]);

  if (!show) return null;

  return (
    <AddToHomeScreen
      onClose={() => {
        localStorage.setItem("addToHomeScreenDismissedAt", Date.now());
        setShow(false);
      }}
      onAdded={() => {
        localStorage.setItem("addToHomeScreenAdded", "true");
        setShow(false);
      }}
    />
  );
}